import { onDocumentReady } from '@src/scripts/lib/event';
import { trackGtmEvent } from '@src/scripts/lib/gtm';
import { observeSelector } from '@src/scripts/lib/intersectionObserver';

onDocumentReady( () => {
	observeSelector( '.dhsv-promo-badge-block', ( entry ) => {
		const storer = entry.target as HTMLElement;
		const textEl = storer.querySelector( '.text' );
		const storerText =
			( textEl && textEl.textContent.replace( /\n/g, '' ) ) || '';

		trackGtmEvent( 'ga_event', {
			category: 'website_promotion',
			promotion_typ: 'stoerer',
			promotion_interaktion: 'view',
			promotion_description: '',
			promotion_text: storerText,
			promotion_link: '',
		} );
	} );
} );
